export default __webpack_public_path__ + "static/media/salman.03bde2b5.png";